import { useStore } from '../store'
import { AxiosInstance } from 'axios'

export function setupAutoUpdateToken(axios: AxiosInstance) {
  const wait = (ms: number) => new Promise(res => setTimeout(res, ms))
  axios.interceptors.response.use(
    function(res) {
      return res
    },
    async function axiosRetryInterceptor(err) {
      const store = useStore()

      if (err.config && err.response && err.response.status === 401) {
        if (store.state.iframe?.handshake) {
          store.state.iframe.handshake.then(parent => {
            parent.emit('refresh-token')
          })
        }
        const retryCount = store.state.retryCount

        if (retryCount >= 5) {
          store.commit('updateRetryCount', 0)
          return Promise.reject(err)
        }
        await wait(2 ** retryCount * 10) // exponential back off time. -> wait for token
        store.commit('updateRetryCount', retryCount + 1)
        return axios.request(err.config)
      }
      return Promise.reject(err)
    }
  )
}
